import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'

import { descriptografar } from '../util/crypto'

import AuthLayout from '../pages/_layouts/Auth'
import DefaultLayout from '../pages/_layouts/Default'
import NoHeaderLayout from '../pages/_layouts/NoHeader'
import LandingPageLayout from '../pages/_layouts/LandingPage'

import { unsignedDefaultPermissions, signedDefaultPermissions } from './defaultRoutes'

const cleanLayoutRoutes = [
    '/produtos/prontuario/comercial'
]

const LandingPageLayoutRoutes = [
    '/',
    '/produtos/prontuario',
    '/politica-privacidade',
    '/termos-de-uso',
    '/contatos',
    '/quem-somos'
]

function clearSessionStorage() {
    sessionStorage.removeItem(process.env.REACT_APP_SESSION_STORAGE_TOKEN)
    sessionStorage.removeItem(process.env.REACT_APP_SESSION_STORAGE_USER)
}

function redirectToLogin() {
    clearSessionStorage()

    return <Redirect to="/" />
}

export default function RouteWrapper({
    component: Component = () => <Redirect to="/login" />,
    isPrivate = false,
    ...rest
}) {
    const token = sessionStorage.getItem(process.env.REACT_APP_SESSION_STORAGE_TOKEN)
    const userData = sessionStorage.getItem(process.env.REACT_APP_SESSION_STORAGE_USER)

    const deciphered = descriptografar(userData)

    if (deciphered?.error) {
        return redirectToLogin()
    }

    const user = (userData && deciphered) || null
    const userPermissions = user?.perfil.grupos.reduce((final, current) => [...final, ...current.permissoes], [])

    const signed = !!token && !!userData
    const currentURL = window.location.href

    if (!signed && currentURL.includes('checkout_auth')) {
        const faturaId = currentURL.split('/').at(-1)

        return <Redirect to={`/checkout/${faturaId}`} />
    }

    if (!signed && isPrivate) {
        return redirectToLogin()
    }

    if (signed && !isPrivate) {
        return redirectToLogin()
    }

    const permissions = signed ? [
        ...signedDefaultPermissions,
        ...userPermissions
    ] : unsignedDefaultPermissions

    const allowed = !!permissions.find(permission => {
        const [baseLink] = permission.link.split('?')

        return baseLink === rest.path
    })

    if (!allowed && rest.path !== '/not_allowed') {
        return <Redirect to="/not_allowed" />
    }

    let Layout

    if(signed) {
        if(cleanLayoutRoutes.some(url => rest.path === url)) {
            Layout = NoHeaderLayout
        } else {
            Layout = DefaultLayout
        }
    } else if(LandingPageLayoutRoutes.includes(rest.path)) {
        Layout = LandingPageLayout
    } else if(cleanLayoutRoutes.some(url => rest.path === url)) {
        Layout = NoHeaderLayout
    } else {
        Layout = AuthLayout
    }

    return (
        <Route
            {...rest}
            component={props => (
                <Layout userData={user}>
                    <Component profile={user?.perfil?.id} {...props} />
                </Layout>
            )}
        />
    )
}

RouteWrapper.propTypes = {
    isPrivate: PropTypes.bool,
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
}
